// extracted by mini-css-extract-plugin
export default {"card":"CoursCard_card__uuTJK"};